'use strict';

goog.provide("Ntry.Restorer");

goog.require("Ntry.STATIC");

Ntry.Restorer = function() {
    Ntry.addEventListener("run", this, this.backup);
    Ntry.addEventListener("stop", this, this.recover);
    this._isBackuped = false;
};

(function(p){
    p.backup = function() {
        var entities = Ntry.entityManager.getEntities();
        _.each(entities, function(entity) {
            var entityId = entity.id;
            var components = entity.components;
            var componentsKeys = _.map(_.keys(components),
                                       function(key) {
                                            return Number(key);
                                       });
            var intersection = _.intersection(componentsKeys,
                                          Ntry.STATIC.RESTORE_COMPONENT_TYPES);
            var restore = {};
            if (!_.isEmpty(intersection)) {
                restore.shouldRestore = Ntry.STATIC.RESTORE_TRUE;
                var backupRowData = Ntry.entityManager.getComponentsJSON(entityId);
                restore.origins = backupRowData.origins;
                restore.data = backupRowData.data;
            } else
                restore.shouldRestore = Ntry.STATIC.RESTORE_FALSE;

            restore.type = Ntry.STATIC.RESTORE;
            Ntry.entityManager.addComponent(entityId, restore);
        });
        this._isBackuped = true;
    };

    p.recover = function() {
        if (!this._isBackuped) return;
        var entityManager = Ntry.entityManager;
        var entities = Ntry.entityManager.getEntities();
        _.each(entities, function(entity) {
            var entityId = entity.id;

            var hasRestoreComponent = entityManager.hasComponent(entityId,
                                        Ntry.STATIC.RESTORE);

            if (hasRestoreComponent) {
                var restoreData = entityManager.getComponent(entityId,
                                        Ntry.STATIC.RESTORE);
                if (restoreData.shouldRestore) {
                    var origins = restoreData.origins;
                    var currentComponents = entityManager.getComponents(entityId);
                    for (var i in currentComponents) {
                        var tempComp = currentComponents[i];
                        if (origins.indexOf(i) < 0)
                            entityManager.removeComponent(entityId, i);
                    }

                    var data = restoreData.data;
                    for (var key in data) {
                        data[key].type = key;
                        entityManager.addComponent(entityId, data[key]);
                    }
                }
            } else
                entityManager.removeEntity(entityId);
        });
        Ntry.dispatchEvent('restoreEnd');
        this._isBackuped = false;
    };

})(Ntry.Restorer.prototype);


